/**
 * @Author: Nenad Brcic
 * @Date: 26.05.16
 * @Email: neno@neno.ch
 */
import Relay from 'react-relay';
import Information from './Information';
import About from '../../About';
import settings from '../../../../config/settings'
import { getCurrentLanguage } from '../../../localData';

const InformationContainer = Relay.createContainer(Information, {
    initialVariables: {
        lang: getCurrentLanguage(),
        limit: settings.defaultLimitNumberOfRecords,
        isInformationVisible: false,
    },
    fragments: {
        store: () => Relay.QL`
            fragment on Store {
                staticTexts(lang: $lang, first: $limit) {
                    edges {
                        node {
                            id,
                            StaType,
                            ${About.getFragment('staticText')}
                        }
                    }
                    
                },
            }
        `,
    }
});

export default InformationContainer;


// WEBPACK FOOTER //
// ./app/components/Main/Information/index.js